import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { SchoolDirectory } from '../models/school.directory';
import { User } from '../models/user';
import { AppConfigService } from './app.config.service';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  // apiUrl = 'https://localhost:32771/profileapi/api';
  api = this.configService.sytemConfiguration.apiUrl;
  private directory$: Observable<SchoolDirectory> | null = null;
  private sectionCache$ = new Map<string, Observable<any>>();

  constructor(private http: HttpClient, private configService: AppConfigService) { }

  getProfileById(id: number): Observable<User> {
    return this.http.get<User>(`${this.api}/user/${id}/profile`);
  }

  getDirectory(): Observable<SchoolDirectory> {
    if (!this.directory$) {
      this.directory$ = this.http.get<SchoolDirectory>(this.api + '/school/directory').pipe(shareReplay(1));
    }
    return this.directory$;
  }

  getSectionByUserId<T>(id: number, section: string): Observable<T[]> {
    const key = `${id}/${section}`;
    if (!this.sectionCache$.has(key)) {
      this.sectionCache$.set(key, this.http.get<T[]>(`${this.api}/user/${id}/${section}`).pipe(shareReplay(1)));
    }
    return this.sectionCache$.get(key) as Observable<T[]>;
  }

}
